import { useMediaQuery } from "@/hooks/use-media-query";
import { UserData } from "modules/authentication/types/user-data";
import { useFetch } from "modules/main/hooks/useFetch";
import { forwardRef } from "react"
import { KPI, LineChartKPI } from "modules/checkout/components/kpi-dashboard";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BadgeDollarSign, Percent, PiggyBank, Receipt, TrendingUp, Target } from "lucide-react";
import { PurchaseData, UserDashboard } from "modules/main/types/user-dashboard";

import { cn } from "@/lib/utils";
import { Progress } from "@/components/ui/progress";
import { dashboardEndPoint } from "modules/main/services/endpoints";
import { FetchDataOptions } from "modules/main/services/fetchData";

import React from "react";
import { OrderHistoryCard, OrderHistoryTable } from "./order-history";
import Amount from "utils/amount";
import { differenceInDays } from "date-fns";



interface UserDashboardProps extends React.HTMLAttributes<HTMLDivElement>{

}

export const UsersDashboard = forwardRef<HTMLDivElement,UserDashboardProps>(({...props},ref) => {
    const userData = JSON.parse(localStorage.getItem("userData")??"{}") as UserData;
    const isDesktop = useMediaQuery("(min-width: 1024px)");
    const requestOptions:FetchDataOptions = {
        method:"GET",
        headers:{"content-type":"application/json"}
    }
    
    const {data: dashboardData,error: dashboardError,loading: dashboardLoading} = useFetch<UserDashboard>(dashboardEndPoint,requestOptions);
    if(dashboardError || !dashboardData){
      return (<></>);
    }

    const hasKpiData =
      dashboardData.cummulateSaving > 0 ||
      dashboardData.lastPurchase > 0 ||
      dashboardData.totalOptimizedPurchases > 0;

    if (!hasKpiData) {
      return (<></>);
    }

    const lastPurchaseDays = differenceInDays(new Date(), new Date(dashboardData.lastPurchaseDate));
    const lastPurchaseText = lastPurchaseDays === 0 ? "hoy" : `hace ${lastPurchaseDays} día${lastPurchaseDays === 1 ? "" : "s"}`;
    const MONTHLY_LIMIT = 20000;
    const progressPercent = Math.min((dashboardData.monthlyTotalSave / MONTHLY_LIMIT) * 100, 100);

    return (
    <div className="flex flex-col gap-4 md:mx-0">                
        <div className="flex flex-col md:flex-row w-full gap-4">
            <KPI icon={PiggyBank} 
              className="w-full md:flex-1 bg-[#5A9E71] text-white" 
              iconClassName="text-white"
              title="Llevas ahorrado" 
              subText="este mes"
              subTitle={
                <div className="flex flex-col gap-2">
                  <div className="flex gap-2 font-semibold text-white">
                    <Amount
                      amount={dashboardData.cummulateSaving}
                      currency="CLP"
                      locale="es-CL"
                      className="font-extrabold"
                    />
                    <span> este año</span>
                  </div>
                  <div className="flex flex-col gap-1.5 pt-2">
                    <div className="flex justify-between text-[11px] font-medium text-white/80">
                      <span>
                        <Amount amount={dashboardData.monthlyTotalSave} currency="CLP" locale="es-CL" />
                      </span>
                      <span>
                        <Amount amount={MONTHLY_LIMIT} currency="CLP" locale="es-CL" />
                      </span>
                    </div>
                    <Progress value={progressPercent} barColor="#ffffff" className="h-2 bg-white/20" />
                    <span className="text-xs text-white/60 font-medium">
                      Has utilizado el <span className='font-bold'>{Math.round(progressPercent)}%</span> de tu cuota mensual
                    </span>
                  </div>
                </div>
              } 
              amount={dashboardData.monthlyTotalSave}/>
             <KPI icon={Receipt} 
              className="w-full md:flex-1" 
              iconClassName=""
              title="Tu última compra"
              subText={lastPurchaseText}
              subTitle={
                <div className="flex gap-2 font-semibold">
                  <span className="text-primary font-bold">{dashboardData.totalOptimizedPurchases}</span>
                  <span>{dashboardData.totalOptimizedPurchases === 1 ? "optimización" : "optimizaciones"}</span>
                </div>
              } 
              amount={dashboardData.lastPurchase}/>
        </div>
    </div>
    );
});


interface OrderHistoryProps extends React.HTMLAttributes<HTMLDivElement> {
    lastPurchases:PurchaseData[]
    isDesktop?:boolean
}

export const OrderHistory = forwardRef<HTMLDivElement,OrderHistoryProps>(({lastPurchases,isDesktop,...props},ref)=>{
    return (
            <Card className={cn("flex flex-col ",props.className)}>
            <CardHeader className={"flex flex-row items-center justify-between space-y-0 pb-2 gap-2"} >
                <CardTitle className="text-xs md:text-sm font-medium">Últimos pedidos</CardTitle>                
            </CardHeader>
            <CardContent>
            {/* {isDesktop?(
                <OrderHistoryTable lastPurchases={lastPurchases}/>
            ):(
                <OrderHistoryCard lastPurchases={lastPurchases}/>
            )}                 */}
            </CardContent>
        </Card>  
    );
})
